import {mapState, mapGetters, mapActions} from 'vuex'
import ApiManager from '@/utils/ApiManager'
import Utility from '@/utils/Utility'

export default {
    name: 'PartnerConfirm',
    data() {
        return {
            processing: false
        }
    },
    computed: {
        ...mapState({
            categoryName: state => state.partner.categoryName,

            // form
            userIdentity: state => state.partnerForm.targetId,
            values: state => state.partnerForm.values,

            // model
            serviceModel: state => state.partnerForm.serviceModel
        }),
        ...mapGetters({
            getValue: 'partnerForm/getValue',
            isRegister: 'partnerForm/isRegister',
            isModify: 'partnerForm/isModify',
        }),

        // result
        resultService() {
            try {
                return this.serviceModel.filter(item => item.serviceUuid === this.values.serviceUuid)[0].serviceName
                // eslint-disable-next-line
            } catch (e) {
                return ''
            }
        },
        resultStatus() {
            try {
                return Utility.getConstantsLabel(['Status'], this.values.status)
                // eslint-disable-next-line
            } catch (e) {
                return ''
            }
        }
    },
    methods: {
        ...mapActions({
            showError: 'error/show',
            showToast: 'toast/show'
        }),
        turnBack() {
            this.$router.go(-1)
        },

        postData() {
            this.processing = true

            let parameters = {
                request: {
                    serviceUuid: this.values.serviceUuid,
                    partnerName: this.values.partnerName,
                    email: this.values.email,
                    status: this.values.status
                }
            }
            if (this.isModify) {
                parameters.partnerUuid = this.values.partnerUuid
            }
            console.log('register data', parameters)

            // 登録
            ApiManager.request(
                ['partner'],
                [this.isRegister ? 'v1PartnerPost' : 'v1PartnerPatch'],
                [parameters])
                .then(res => {
                    this.processing = false
                    let status = Utility.parseResponse(res)

                    if (status.result) {
                        // toast
                        this.showToast({
                            title: this.isRegister ?
                                '新しい' + this.categoryName + 'の登録' :
                                this.categoryName + '情報の変更',
                            body: this.isRegister ?
                                '「' + this.values.partnerName + '」を登録しました。' :
                                '指定' + this.categoryName + 'の情報を変更しました。'
                        })

                        this.$router.push({
                            name: 'Partner'
                        })

                    } else if (status.error) {
                        // エラーメッセージ表示
                        this.showError(res)
                    } else {
                        // アプリケーションエラー表示
                        this.showError(null)
                    }

                })
                // eslint-disable-next-line
                .catch(error => {
                    this.processing = false
                    this.showError(null)
                })
        }
    }
}
